exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.sidebar-item-text[data-v-22521f0c] {\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  line-height: 16px;\n  overflow: hidden;\n  width: 100%;\n  display: inline-block;\n}\n", "", {"version":3,"sources":["/var/jenkins_home/workspace/pro-maibenben-mall-admin-front/src/views/layout/components/Sidebar/SidebarItem.vue"],"names":[],"mappings":";AACA;EACE,wBAAwB;EACxB,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;EACZ,sBAAsB;CACvB","file":"SidebarItem.vue","sourcesContent":["\n.sidebar-item-text[data-v-22521f0c] {\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  line-height: 16px;\n  overflow: hidden;\n  width: 100%;\n  display: inline-block;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-22521f0c","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/layout/components/Sidebar/SidebarItem.vue
// module id = mr8d
// module chunks = 65